















import { Component, Prop, Vue } from "vue-property-decorator";
import MiraPartsLegendComponent from "@/components/mira/MiraPartsLegend.vue";
import { MiraSegment } from "@/utils/MiraDataQualityView";

/**
 * A part-to-whole bar with its legend: the meter-reading states of the ended assignments.
 *
 * The parts are separated by a 2px gap in the surface colour, not by drawn borders, and the legend
 * lists every part with its count and share, including the empty ones, so the values are readable
 * without the bar and a segment too thin to see is never the only place a number lives.
 */
@Component({
  components: {
    "mira-parts-legend": MiraPartsLegendComponent,
  },
})
export default class MiraStackedBarComponent extends Vue {
  @Prop({ required: true })
  segments!: MiraSegment[];

  get visibleSegments() {
    return this.segments.filter((segment) => segment.value > 0);
  }

  /** The bar as one sentence for screen readers. */
  get ariaLabel() {
    return this.segments.map((segment) => `${segment.label}: ${segment.valueText}`).join(", ");
  }
}
